webpackJsonp([76851799919888],{

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.partnersQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(49);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Styling = __webpack_require__(18);
	
	var _HTMLtoJSX = __webpack_require__(77);
	
	var _HTMLtoJSX2 = _interopRequireDefault(_HTMLtoJSX);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StyledPage = (0, _styledComponents2.default)(_Styling.PageWrapper).withConfig({
	  displayName: 'partners__StyledPage'
	})(['flex:1;p{margin-top:0;}']);
	
	exports.default = function (_ref) {
	  var data = _ref.data,
	      transition = _ref.transition;
	  var page = data.markdownRemark;
	
	  return _react2.default.createElement(
	    StyledPage,
	    { maxWidth: _Styling.Measures[2], style: transition && transition.style },
	    _react2.default.createElement(
	      _Styling.Heading,
	      null,
	      page.frontmatter.title
	    ),
	    _react2.default.createElement(_HTMLtoJSX2.default, { content: page.html })
	  );
	};
	
	var partnersQuery = exports.partnersQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-partners-js-d9842dfc438be670dffe.js